module.exports = __webpack_public_path__ + "index_assets/img/ask_bg.cfec6b03.png";